import React from 'react';
const getPath = (path) => `https://haven.com${path}`.toLowerCase();
export const getBreadcrumbSchema = (breadcrumbs) => {
    return {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: breadcrumbs.map((crumb, index) => {
            return {
                '@type': 'ListItem',
                position: index + 1,
                item: {
                    '@id': getPath(crumb.path),
                    name: crumb.title,
                },
            };
        }),
    };
};
const SchemaScript = ({ breadcrumbs }) => (<script type='application/ld+json' dangerouslySetInnerHTML={{
        __html: JSON.stringify(getBreadcrumbSchema(breadcrumbs)),
    }}/>);
export default SchemaScript;
